import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../components/common/button/Button";
import TextField from "../../../components/common/textfield/TextField";
import logo from "../../../assets/images/AO-logo-black.jpg";
import { routeNames } from "../../../consts/routesNames";
import { ValidateFields, ValidatePassword } from "../../../utils/formValidation";
import { passwordResetConfirm } from "../../../apis/authenticationApis/passwordResetConfirm";
import "./ForgotPasswordReset.css";

function ForgotPasswordReset() {
  const [passwordState, setPasswordState] = useState("");
  const [confirmPasswordState, setConfirmPasswordState] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const emailState = location?.state?.email || "";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!ValidateFields(emailState)) {
      alert("Email is missing. Please start again.");
      navigate(routeNames.FORGOT_PASSWORD_EMAIL);
      return;
    }
    if (!ValidateFields(passwordState)) {
      alert("The Password field is required");
      return;
    }
    if (!ValidateFields(confirmPasswordState)) {
      alert("The Confirm Password field is required");
      return;
    }

    const validatePassword = ValidatePassword(
      passwordState,
      confirmPasswordState
    );
    if (validatePassword !== true) {
      alert(validatePassword);
      return;
    }

    const response = await passwordResetConfirm(emailState, passwordState);
    if (response.error_code === 1) {
      alert("Password reset successfully.");
      navigate(routeNames.LOGIN);
    } else {
      alert(response.error_message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="forgot-password-reset-body-container">
        <div className="forgot-password-reset-main-container">
          <img className="forgot-password-reset-logo" src={logo} alt="" />
          <div className="forgot-password-reset-card-container">
            <div className="forgot-password-reset-labeltext-main-container">
              <div className="forgot-password-reset-labeltext-container">
                <TextField
                  label={"Create New Password"}
                  name="password"
                  type="password"
                  setValue={setPasswordState}
                  value={passwordState}
                  placeHolder="Please Enter Your Password ...."
                  isRequired={true}
                  maxLength={100}
                  autoComplete="new-password"
                />
              </div>
              <div className="forgot-password-reset-labeltext-container">
                <TextField
                  label={"Confirm New Password"}
                  name="confirm_password"
                  type="password"
                  setValue={setConfirmPasswordState}
                  value={confirmPasswordState}
                  placeHolder="Please Confirm Your Password ...."
                  isRequired={true}
                  maxLength={100}
                  autoComplete="new-password"
                />
              </div>
              <div className="forgot-password-reset-buttons-container">
                <div className="forgot-password-reset-button-container">
                  <Button className="login" buttonText={"Reset"} type="submit" />
                </div>
              </div>
              <div className="forgot-password-reset-link-container">
                <button
                  className="forgot-password-reset-link-button"
                  type="button"
                  onClick={() => navigate(routeNames.LOGIN)}
                >
                  Back to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default ForgotPasswordReset;
